import { takeLatest, call, put } from 'redux-saga/effects';
import { createAction } from '@reduxjs/toolkit';
import { push } from 'connected-react-router';
import request from '../../Utils/Request';
import { makeUndefined } from '../../Utils/validationUtil';
import { storeModels, storeUserDevices } from './ModelList.reducer';
import { enableLoader, showMessageToast } from '../Login/Login.reducer';
import { enableImportLoader } from '../../Common/common.reducer';
import { storeInferenceDetails } from '../Inference/Inference.reducer';

export const fetchModels = createAction('FETCH_MODELS');
export const modelImport = createAction('IMPORT_MODEL');
export const modelDelete = createAction('DELETE_MODEL');
export const modelArchive = createAction('ARCHIVE_MODEL');
export const inferenceStart = createAction('START_INFERENCE');
export const fetchUserDevices = createAction('FETCH_USER_DEVICES');

function* getModelList(action) {
  const { params, callback } = action.payload;
  const conditionCheck =
    params.sortBy === '' &&
    params.sortDirection === '' &&
    params.searchValue === '';
  try {
    if (conditionCheck) {
      yield put(enableLoader(true));
    }
    const payload = makeUndefined(params);
    const response = yield call(request, '/rest/model/fetchModels', {
      data: {
        ...payload,
        offset: params.searchValue ? 0 : payload.offset,
      },
      action,
    });
    if (response.status === 200 && response.entity && response.entity.models) {
      yield put(storeModels(response.entity));
      if (
        response.entity &&
        response.entity.models &&
        response.entity.models.length
      ) {
        if (callback) {
          callback(response.entity.models[0]);
        }
      } else if (callback) {
        callback({});
      }
    }
    if (conditionCheck) {
      yield put(enableLoader(false));
    }
  } catch (error) {
    if (conditionCheck) {
      yield put(enableLoader(false));
    }
    yield put(
      showMessageToast({
        show: true,
        message: error.message ? error.message : 'Fetching models unsuccessful',
        type: 'error',
      })
    );
  }
}
function* importModel(action) {
  try {
    const { currentModel, callback } = action.payload;
    yield put(enableImportLoader(true));
    if (callback) callback();
    const response = yield call(request, '/rest/model/import', {
      data: currentModel.fileObj,
      customHeader: {
        'Content-Type': 'multipart/form-data;',
      },
      action,
    });
    if (response.status === 200) {
      yield put(enableImportLoader(false));
      yield put(
        fetchModels({
          params: {
            offset: 0,
            size: 7,
          },
        })
      );
      yield put(
        showMessageToast({
          show: true,
          message: response.message
            ? response.message
            : 'Model imported successfully',
          type: 'success',
        })
      );
    }
  } catch (error) {
    yield put(enableImportLoader(false));
    yield put(
      showMessageToast({
        show: true,
        message: error.message ? error.message : 'Model import unsuccessful',
        type: 'error',
      })
    );
  }
}
function* deleteModel(action) {
  try {
    // const { payload, callback } = action.payload;
    // const response = yield call(request, `/rest/training/model/deleteModels?modelIds=${payload}`,
    // 	{
    // 		method: 'DELETE',
    // 		action
    // 	});
    // if (response.status === 200) {
    // 	yield put(deleteModelFromList(payload));
    // 	if (callback) callback();
    // }
  } catch (error) {
    console.log(error);
  }
}
function* archiveModel(action) {
  try {
    // const { payload, callback } = action.payload;
    // const response = yield call(request, `/rest/training/model/deleteModels?modelIds=${payload}`,
    // 	{
    // 		method: 'DELETE',
    // 		action
    // 	});
    // if (response.status === 200) {
    // 	yield put(deleteModelFromList(payload));
    // 	if (callback) callback();
    // }
  } catch (error) {
    console.log(error);
  }
}
function* startInference(action) {
  const { data, callback } = action.payload;
  try {
    const response = yield call(request, `/rest/runtime-inference/start`, {
      method: 'POST',
      data,
      action,
    });
    if (response.status === 200 && response.entity) {
      yield put(
        storeInferenceDetails({
          entity: response.entity,
          modelId: data.modelId,
        })
      );
      yield put(
        push(
          `/model-list/${data.modelId}/inference/${response.entity.runtimeUuid}`
        )
      );
      yield put(
        showMessageToast({
          show: true,
          message: 'Inference started successfully',
          type: 'success',
        })
      );
    } else {
      callback();
      throw new Error('Failed to start inference');
    }
  } catch (error) {
    callback();
    yield put(
      showMessageToast({
        show: true,
        message: error.message ? error.message : 'Failed to start inference',
        type: 'error',
      })
    );
  }
}

function* getDevices(action) {
  const { params, callback } = action.payload;
  try {
    const payload = makeUndefined(params);
    const response = yield call(request, `/rest/input-clients`, {
      method: 'POST',
      data: payload,
      action,
    });
    if (
      response.status === 200 &&
      response.entity &&
      response.entity.inputClients
    ) {
      yield put(
        storeUserDevices({
          data: response.entity.inputClients,
          mode: params.offset === 0,
        })
      );
      callback(response.entity.inputClients.length);
    }
  } catch (error) {
    yield put(
      showMessageToast({
        show: true,
        message: error.message
          ? error.message
          : 'Fetching devices unsuccessful',
        type: 'error',
      })
    );
  }
}

export default function* modelListSaga() {
  const watcher = [];
  watcher.push(yield takeLatest(fetchModels.toString(), getModelList));
  watcher.push(yield takeLatest(modelImport.toString(), importModel));
  watcher.push(yield takeLatest(modelDelete.toString(), deleteModel));
  watcher.push(yield takeLatest(modelArchive.toString(), archiveModel));
  watcher.push(yield takeLatest(inferenceStart.toString(), startInference));
  watcher.push(yield takeLatest(fetchUserDevices.toString(), getDevices));
}
